/**
 * @param {string} file
 * @param {string} ext
 * @return string
 */
export function addFileExtension(file, ext = '.png') {
  return /.*\.[\w\d]+$/.test(file) ? file : `${file}${ext}`
}